/**
 * Discounts API Mutations
 *
 * Write operations.
 */

import { apiClient } from '../client';
import type { CalculationType } from '../calculationType';
import type { Discount } from './types';

export interface CreateDiscountPayload {
  name: string;
  amount: string;
  calculation_type: CalculationType;
  /** Dollar ceiling on the computed discount. Null means no cap. */
  max_value?: string | null;
}

export interface UpdateDiscountPayload {
  name: string;
  amount: string;
  calculation_type: CalculationType;
  description?: string | null;
  /** Dollar ceiling on the computed discount. Null means no cap. */
  max_value?: string | null;
}

export interface DiscountResponse {
  discount: Discount;
}

export async function createDiscount(payload: CreateDiscountPayload): Promise<DiscountResponse> {
  const { data } = await apiClient.post<DiscountResponse>('/api/discounts', { discount: payload });
  return data;
}

export async function updateDiscount(id: number, payload: UpdateDiscountPayload): Promise<DiscountResponse> {
  const { data } = await apiClient.patch<DiscountResponse>(`/api/discounts/${id}`, { discount: payload });
  return data;
}

export async function deleteDiscount(id: number): Promise<void> {
  await apiClient.delete<void>(`/api/discounts/${id}`);
}
